/**
 * Single source of truth for how dates read across the admin: Czech locale,
 * day-month-year, and — for datetimes — hours + minutes only, never seconds.
 * Route every ad-hoc formatter and DataGrid date column through these so the
 * whole admin stays consistent (client request: "cs,cs datumy, vteřiny pryč").
 */
const dateFormat = new Intl.DateTimeFormat('cs-CZ', { dateStyle: 'medium' })
const dateTimeFormat = new Intl.DateTimeFormat('cs-CZ', { dateStyle: 'medium', timeStyle: 'short' })

function toDate(value: unknown): Date | null {
	if (value == null || value === '') return null
	const date = value instanceof Date ? value : new Date(value as string | number)
	return Number.isNaN(date.getTime()) ? null : date
}

export function formatCzechDate(value: unknown): string | null {
	const date = toDate(value)
	return date ? dateFormat.format(date) : null
}

export function formatCzechDateTime(value: unknown): string | null {
	const date = toDate(value)
	return date ? dateTimeFormat.format(date) : null
}
